var header = {
  pro: "Young Platform Pro",
  base: "Young Platform",
  step: "Young Platform Step",
  login: "Accedi",
  login_text: "Hai già  un account?",
  signup: "Registrati",
  signup_text: "Non hai un account?",
  access: "Entra",
  start: "Inizia ora",
  menu: {
    dashboard: "Home",
    giftcard: "Gift card",
    markets: "Mercati",
    wallet: "Portafoglio",
    settings: "Account",
    help: "Supporto",
    logout: "Esci",
    info: "Informazioni"
  }
};
var copyright = "Young Platform S.p.a. Tutti i diritti riservati.";
var view_more = {
  btn: "Mostra di più"
};
var textfield = {
  password_minimum_length: "Almeno 8 caratteri, numeri, lettere minuscole e maiuscole",
  password_weak: "Password strenght: *color*weak*color*",
  password_improved: "Password strenght: *color*improved*color*",
  password_strong: "Password strenght: *color*strong*color*"
};
var It = {
  header: header,
  copyright: copyright,
  "join-community": {
    title: "Unisciti alla *color*community*color*",
    newsletter_title: "*color*Ricevi*color* tutti gli update",
    newsletter_caption: "Ricevi news di mercato e aggiornamenti su partnership e listing di nuove monete.",
    newsletter_placeholder: "Inserisci l'email",
    newsletter_button: "Iscriviti",
    newsletter_registered: "Grazie per la registrazione!"
  },
  "landing-footer": {
    product: "Prodotti",
    company: "Azienda",
    support: "Supporto",
    careers: "Lavora con noi",
    about: "Chi Siamo",
    learn: "Impara",
    learn1: "Comprare Bitcoin in 5 Mosse",
    learn2: "Bitcoin: Guida per Principianti",
    learn3: "Guadagna Basic Attention Token (BAT)",
    buy1: "Come comprare Bitcoin",
    buy2: "Come comprare Ethereum",
    buy3: "Come comprare Polkadot",
    download: "Scarica l'app",
    service_center: "Supporto",
    glossary: "Glossario",
    faq_1: "Tassazione",
    faq_2: "Compravendita",
    faq_3: "Commissioni",
    whyUs: "Perché Young Platform",
    ambassador: "Diventa Ambassador",
    pressKit: "Press Kit",
    blog: "Blog",
    conditions: "Condizioni",
    events: "Eventi",
    language: "Lingua",
    it: "Italiano",
    en: "Inglese",
    newsletter: "Newsletter",
    talking: "Parlano di noi",
    footer_terms: "Termini e Condizioni",
    footer_terms_step: "Termini e Condizioni - Step",
    refund_policy: "Politica di rimborso",
    select_lang: "Seleziona la lingua",
    commission_price: "Commissioni e Prezzi",
    sub_copyright: "Young Platform S.p.a. Via Francesco Cigna 96/17, 10155, Torino, Italia P. Iva 11931440017",
    contact_us: "Contattaci",
    "talking-about-us": "Parlano di noi"
  },
  view_more: view_more,
  textfield: textfield
};
export { copyright, It as default, header, textfield, view_more };